import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { CredentialsService } from '@shared/services/web/credentials.service';
import { SignInModalComponent } from '@app/security/modals/sign-in-modal/sign-in-modal.component';

/**
 * La ruta /ingresar es un link legado que asesores comerciales siguen
 * enviando a clientes para que se den de alta. Antes renderizaba una pagina
 * de login desactualizada (LoginComponent); este guard evita esa pagina y
 * abre el modal de registro actual en su lugar, igual que el boton
 * "Registrate" del header.
 */
@Injectable({
  providedIn: 'root',
})
export class OpenSignUpModalGuard implements CanActivate {
  constructor(
    private router: Router,
    private credentialsService: CredentialsService,
    private readonly dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    this.router.navigate(['']).then(() => {
      if (
        isPlatformBrowser(this.platformId) &&
        !this.credentialsService.isAuthenticated()
      ) {
        this.dialog.open(SignInModalComponent, {
          maxWidth: '95vw',
          panelClass: 'icon-logo-modal',
        });
      }
    });
    return of(false);
  }
}
